import React from 'react'

import { ErrorLayout } from './ErrorLayout'

type Error404Props = {
  //
}

export const Error404: React.FC<Error404Props> = () => (
  <ErrorLayout code="404" title="Страница не найдена">
    <p>
      Неправильно набран адрес или такой страницы на сайте больше не существует.
    </p>
  </ErrorLayout>
)
